var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from './svg-circle-icon';
export var YouTubeFilledIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 64,
    glyphHeight: 65
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2218 6.36759C19.4842 2.85138 25.671 0.974609 32 0.974609C40.487 0.974609 48.6262 4.34603 54.6274 10.3472C60.6286 16.3483 64 24.4876 64 32.9746C64 39.3036 62.1232 45.4904 58.607 50.7528C55.0908 56.0152 50.0932 60.1168 44.2458 62.5388C38.3986 64.9608 31.9646 65.5944 25.7572 64.3598C19.5497 63.125 13.8479 60.0772 9.37261 55.602C4.89733 51.1268 1.84961 45.4248 0.614885 39.2174C-0.619841 33.01 0.0138645 26.576 2.43587 20.7287C4.85787 14.8815 8.95939 9.88379 14.2218 6.36759ZM16.097 19.8189C19.5402 18.8351 31.8374 18.8351 31.8374 18.8351C31.8374 18.8351 44.6264 18.8351 47.5778 19.8189C49.0534 20.3108 50.529 21.7864 51.021 23.262C52.0046 26.7052 52.0046 33.0998 52.0046 33.0998C52.0046 33.0998 52.0046 39.9862 51.021 42.9376C50.529 44.4132 49.0534 45.8888 47.5778 46.3808C44.1346 47.3646 31.8374 47.3644 31.8374 47.3644C31.8374 47.3644 19.0483 47.3646 16.097 46.3808C14.6213 45.8888 13.1457 44.4132 12.6538 42.9376C11.67 39.4944 11.67 33.0998 11.67 33.0998C11.67 33.0998 11.67 26.2134 12.6538 23.262C13.1457 21.7864 14.6213 20.3108 16.097 19.8189ZM38.2318 33.0998L27.9022 27.1972V39.0024L38.2318 33.0998Z"
  }));
};
export var YouTubeFilledIconGlyph = function (props) {
  return React.createElement(YouTubeFilledIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};